import { Box, Grid, Skeleton, Typography } from '@mui/material'
import React from 'react'

const SellerInfoSkeleton = () => {
    return (
        <div className='grid grid-cols-1 grid-rows-5 px-5  overflow-y-auto h-[calc(100svh-140px)]'
            style={{ gridTemplateRows: 'auto' }}
        >
            {/* store banner section */}
            <div className='place-content-center py-3'>
                <Grid container justifyContent={"flex-start"} alignItems={"center"} gap={"45px"} flexDirection={"column"}>
                    <Grid item sx={{ width: '100%' }}>
                        <Box sx={{ width: '100%', borderRadius: "5px", position: "relative" }}>
                            <Skeleton width={"100%"} height={150} sx={{ transform: 'unset' }} />
                            <Box sx={{ position: "absolute", bottom: "-40px", right: "20px", width: "80px", height: "80px", borderRadius: "50%", background: "#fff", boxShadow: "0px 2px 4px rgba(0,0,0,0.4)" }}>
                                <Skeleton width={"100%"} height={"100%"} variant='circular' />
                            </Box>
                        </Box>

                    </Grid>
                    <Grid item width={"100%"} sx={{ paddingRight: "20px !important" }}>
                        <Grid container justifyContent={"space-between"} alignItems={"flex-end"}>
                            <Box sx={{ display: "flex", alignItems: "flex-start", flexDirection: 'column', justifyContent: "center" }}>
                                <Grid item>
                                    <Skeleton width={100} height={20} />
                                </Grid>
                                <Grid item>
                                    <Skeleton width={100} height={20} />

                                </Grid>
                            </Box>

                            <Grid item>
                                <Skeleton width={100} height={20} />

                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
            {/* store categoreis section */}
            <div className='place-content-center px-5 border-t py-3'>
                <Typography sx={{ fontSize: "1rem", marginBottom: "1rem" }}>
                    زمینه فعالیت فروشگاه
                </Typography>
                {[...Array(2)].map((_, index) => (
                    <Skeleton key={index} width={100} height={20} />
                ))}
            </div>
            {/* store info section */}
            <div className='border-t border-b place-content-center py-3 text-justify px-5'>

                <Typography sx={{ fontSize: ".9rem" }}>
                    <Skeleton width={100} height={20} />

                </Typography>
            </div>
            {/* store address and phone section */}
            <div className='place-content-center px-5 py-2'>
                <Typography sx={{ fontSize: "1rem", marginBottom: "1rem" }}>
                    آدرس و اطلاعات تماس
                </Typography>
                <Typography sx={{ fontSize: ".9rem" }}>
                    <Skeleton width={200} height={20} />

                </Typography>
            </div>
            {/* store cards section */}
            <Skeleton width={200} height={20} />

        </div >
    )
}

export default SellerInfoSkeleton